import { CommonModule } from '@angular/common';
import { SmartIconComponent } from './components/smart-icon/smart-icon';
import { NgModule } from '@angular/core';
import { UnescapeHtmlPipe } from './pipe/unescape-html-pipe';
import {TranslateModule} from '@ngx-translate/core';
import { PinchZoomModule } from './components/ivypinch_pro_ng8/pinch-zoom.module';
import { FullscreenGalleryComponent } from './components/fullscreen-gallery/fullscreen-gallery.component';
import { AccessoryDetailComponent } from './components/accessory-detail/accessory-detail.component';
import {ZoomableImageComponent} from './components/zoomable-image/zoomable-image.component';

import { IonicModule } from '@ionic/angular';
import { ModalSimpleMessageComponent } from './components/modals/modal-simple-message/modal-simple-message.component';
import { SwiperModule } from 'swiper/angular';
import { ToLocalUrlPipe } from './pipe/to-local-url.pipe';

@NgModule({
    imports: [CommonModule, PinchZoomModule, IonicModule, SwiperModule, ToLocalUrlPipe],
    declarations: [SmartIconComponent, UnescapeHtmlPipe, AccessoryDetailComponent,FullscreenGalleryComponent, ZoomableImageComponent, ModalSimpleMessageComponent],
    exports: [TranslateModule, SmartIconComponent, UnescapeHtmlPipe, AccessoryDetailComponent,FullscreenGalleryComponent, ZoomableImageComponent, ModalSimpleMessageComponent]
})
export class SharedModule {}